export default {
    api_url: 'https://ekycbe.mynt.in/zebu',
    api_img: 'https://ekycbe.mynt.in',
    apipan: 'https://ekycbe.mynt.in/kra',
    hyv: 'https://auth.hyperverge.co/',
    dashboard:'https://ekycbe.mynt.in/dashboard',
    pdf_v2: 'https://ekycbe.mynt.in/pdf_v2/zebu',
    

    // api_url: 'https://ekycbe.mynt.in/uat/uat/zebu',
    // api_img: 'https://ekycbe.mynt.in/uat/uat/',
    // apipan: 'https://ekycbe.mynt.in/uat/uatdd/',

    cams: 'https://rekycbe.mynt.in/cams',

    // apiDurl: 'http://192.168.5.81:5004'
    // https://ekycbe.mynt.in/uat/uat
    //'https://zsync.zebull.in/zebu' 
}

var api_url = 'https://ekycbe.mynt.in/zebu';
// var api_url = 'http://192.168.5.81:5004/';


let myHeaders = new Headers();
var requestOptions = {
    method: 'POST',
    redirect: 'follow',
    headers: myHeaders
};
myHeaders.append("Content-Type", "application/json");

export async function getStartdata(m) {
    var response = await fetchMyntAPI(api_url + '/getstart?mob=' + m, requestOptions)
    return response
}

export async function getStartAction(item, type) {
    requestOptions['body'] = item
    var response = await fetchMyntAPI(api_url + '/getstart?mob=' + atob(localStorage.getItem('hash')) + `&type=${type}`, requestOptions)
    return response
}

// Website Lead API -- see website-lead-api.md. This is the <website-backend-host>
// the docs refer to.
var lead_url = 'https://dwld.zebuetrade.com';

// The referral codes allowed to create a lead -- matched case-insensitively. Served
// as a static file so a code can be added or removed without a front-end release.
var lead_refs_url = 'https://ekycbe.mynt.in/static/lead-refs.json';

export async function getLeadRefs() {
    try {
        // no-store so a code added to the file takes effect on the next page load
        // rather than whenever the browser decides its cached copy went stale.
        var response = await fetch(lead_refs_url, { cache: 'no-store' });
        if (!response.ok) {
            throw new Error('HTTP ' + response.status)
        }
        var refs = await response.json();
        return Array.isArray(refs) ? refs : []
    } catch (error) {
        // Fail closed -- an unreachable list means no lead is queued, which is
        // better than guessing at an allowlist we could not read.
        console.log('lead refs fetch failed:', error.message)
        return []
    }
}

// The CRM secret stays on the website server, so this endpoint is safe to call
// straight from the browser.
export async function submitWebsiteLead(fields) {
    var response = await fetch(lead_url + '/api/lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fields),
        keepalive: true
    });

    var data = await response.json().catch(function () { return {} });

    // 202 is the only success -- the lead is durably queued, not yet in the CRM.
    if (response.status != 202) {
        throw new Error(data.error_code || data.error || 'HTTP ' + response.status)
    }
    return data.external_id
}

async function fetchMyntAPI(path, requestOptions) {
    try {
        const response = await fetch(path, requestOptions);
        let data = await response.json();
        data = JSON.stringify(data);
        data = JSON.parse(data);
        return data
    } catch (error) {
        let data = 500
        return data
    }
}